export default async ({ store, route, redirect }) => {
  await store.dispatch("language/setDir");
};
